export const LIST_CAPS = {
	payInThree: 12,
	deferredPayments: 12,
	installments: 12,
	transactions: 12,
	offers: 8,
	orderItemNames: 3,
	currentOrderItemNames: 12,
} as const;
